<template>
  <div class="profile__block profile__block--add-border">
    <div
      @click="toggleLabels"
      :class="{ 'is-opened': showLabels }"
      class="profile__action profile__action--toggle"
      role="button"
    >
      <div class="profile__action-icon">
        <price-tag-icon />
      </div>
      <div class="profile__action-text">{{ $t("chat.labels") }}</div>
    </div>
    <template v-if="showLabels">
      <info :userLabels="userLabels" />
      <div
        class="profile__action profile__action--with-margin"
        role="button"
        v-if="!isHistory"
      >
        <div class="profile__action-icon">
          <edit-icon @click="$modal.show('label-modal')" />
        </div>
      </div>
      <div v-else class="profile__action-button">
        <hcc-button @click="$modal.show('label-modal')" size="sm">
          {{ $t("chat.manage-labels") }}
        </hcc-button>
      </div>
    </template>
    <manager-labels
      :options="labelsPredefinided || []"
      :userLabels="userLabels || []"
      :clientId="clientId"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Info from '@/components/labels/Info.vue';
import EditIcon from '@/assets/icons/edit.svg';
import PriceTagIcon from '@/assets/icons/price-tag.svg';
import HccButton from '@/components/shared/HccButton/index.vue';

export default {
  props: {
    userLabels: {
      type: Array,
      required: true,
      default: () => [],
    },
    campaignId: {
      type: String,
      required: true,
      default: null,
    },
    clientId: {
      type: String,
      required: true,
      default: null,
    },
  },
  components: {
    Info,
    EditIcon,
    PriceTagIcon,
    HccButton,
    ManagerLabels: () => import('@/components/labels/Manager.vue'),
  },
  data: () => ({
    showLabels: true,
  }),
  computed: {
    ...mapGetters([
      'labelsByCampaignId',
    ]),
    labelsPredefinided() {
      const labelsByCampaignId = this.labelsByCampaignId(this.campaignId)[0];
      if (labelsByCampaignId && this.userLabels && this.userLabels.length > 0) {
        return labelsByCampaignId.concat(this.userLabels.map((label) => label.key));
      }
      return labelsByCampaignId;
    },
  },
  methods: {
    toggleLabels() {
      this.showLabels = !this.showLabels;
    },
  },
};
</script>
